import axios from 'axios';
import EndPointInfo from '../utility/Endpoints';

const { rapiGatewayEndpoint } = EndPointInfo;

const postRequest = async (initialContactId, contactId, action) => {
  const body = {
    contactId,
    action, // suspend || resume
  };

  if (initialContactId === null) {
    body.initialContactId = contactId;
  } else {
    body.initialContactId = initialContactId;
  }
  return axios.post(rapiGatewayEndpoint, body, {
    headers: {
      'X-API-Key': process.env.REACT_APP_API_GATEWAY_API_KEY,
    },
  });
};

export default async (
  initialContactId, contactId, action,
) => postRequest(initialContactId, contactId, action);
